module.exports = __webpack_public_path__ + "assets/img/sh10.5bcd8efa.jpg";